import React, { FC } from 'react';
import { Button, Grid } from '@mui/material';
import { Input } from '../../../../../../../shared/ui/form/input/Input';
import { DateInput } from '../../../../../../../shared/ui/form/date/Date';
import { GenericIcon } from '../../../../../../../shared/genericIcon/GenericIcon';
import { themeMUI } from '../../../../../../../../theme/theme';
import { useArraySection } from '../../../../useArraySection';

import { useErrorEndDate } from '../../../acromegaly/useErrorEndDate';
import { initialTreatmentBeforeOperationCabergoline } from './TreatmentBeforeOperationCabergoline.helper';
import {
  ITreatmentBeforeOperationCabergoline,
  ITreatmentBeforeOperationCabergolineProps
} from './TreatmentBeforeOperationCabergoline.types';

export const TreatmentBeforeOperationCabergoline: FC<ITreatmentBeforeOperationCabergolineProps> = ({id, initial, handleAddTreatmentBeforeOperationCabergoline, editable, handleDeleteTreatmentBeforeOperationCabergoline}) => {
  const {formik, handleOnClick, disabledAdd} = useArraySection<ITreatmentBeforeOperationCabergoline>(initial ?? initialTreatmentBeforeOperationCabergoline, handleAddTreatmentBeforeOperationCabergoline)

  const errorDate = useErrorEndDate(formik, formik.values.dateStart, formik.values.dateEnd)

  return <>
    {!editable &&  <Grid item xs={0.5} mt={1} mb={editable ? 0: 1} display={'flex'} flexDirection={'column'} alignItems={'flex-start'}
                         justifyContent={'center'}>
      {Number(id) + 1}.
    </Grid>}
    <Grid item xs={3.6} mt={1} mb={editable ? 0: 1}>
      <Input
        type={'text'}
        disabled={!editable}
        name={'dose'}
        placeholder={'dawka (mg/tydzień)'}
        label={'Dawka (mg/tydzień)'}
        onChange={formik.handleChange}
        value={formik.values.dose} />
    </Grid>

    <Grid item xs={3.6} pl={1} mt={1} mb={editable ? 0: 1}>
      <DateInput
        disabled={!editable}
        label={'okres - OD'}
        required={true}
        views={['year', 'month']}
        openTo={'year'}
        name={'dateStart'}
        inputFormat={'mm.yyyy'}
        value={formik.values.dateStart}
        onBlur={() => formik.setFieldTouched('dateStart', true)}
        onChange={(e) => formik.setFieldValue('dateStart', e)} />
    </Grid>
    <Grid item xs={3.6} pl={1} mt={1} mb={editable ? 0: 1}>
      <DateInput
        disabled={!editable}
        label={'okres - DO'}
        isStill={true}
        required={true}
        views={['year', 'month']}
        openTo={'year'}
        name={'dateEnd'}
        error={errorDate}
        inputFormat={'mm.yyyy'}
        value={formik.values.dateEnd}
        isActive={formik.values.dateEndIsActive}
        setIsActive={() => formik.setFieldValue('dateEndIsActive', !formik.values.dateEndIsActive)}
        onBlur={() => formik.setFieldTouched('dateEnd', true)}
        onChange={(e) => formik.setFieldValue('dateEnd', e)} />
    </Grid>
    {handleDeleteTreatmentBeforeOperationCabergoline &&
      <Grid item xs={0.5} pl={1} display={'flex'} justifyContent={'center'}>
        <div style={{ margin: 'auto' }} onClick={() => {
          if (typeof id === 'number') {
            handleDeleteTreatmentBeforeOperationCabergoline(id);
          }
        }}>
          <GenericIcon
            iconName='Close'
            style={{
              color: themeMUI.palette.primary.main,
              cursor: 'pointer',
              verticalAlign: 'middle'
            }} />
        </div>
      </Grid>
    }
    {handleAddTreatmentBeforeOperationCabergoline &&
      <Grid item xs={1} pl={1} pt={1} display={'flex'} justifyContent={'center'}>
        <Button disabled={disabledAdd || errorDate} variant='contained' color={'primary'}
                onClick={handleOnClick}>ZAPISZ</Button>
      </Grid>
    }
  </>;
}